
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { G as kebabify, y as cloneVNode } from './index-2216d089.js';
import './chakra-ui-styled-system.esm-a8a2e91f.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-de5da461.js';
import CBox from './CBox.js';
import { S as StringArray } from './props.types-cbb7b1ff.js';
import { i as inputSizes } from './input.styles-382a5002.js';

/**
 * Hey! Welcome to @chakra-ui/vue CInputGroup
 *
 * CInputGroup allows grouping of input elements
 *
 * @see Docs     https://vue.chakra-ui.com/input
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CInputGroup/CInputGroup.js
 */
/**
 * CInputElement component
 *
 * allows grouping of input elements
 *
 * @extends CBox
 * @see Docs https://vue.chakra-ui.com/input
 */

var CInputGroup = {
  name: 'CInputGroup',
  functional: true,
  inject: ['$chakraTheme'],
  props: {
    size: {
      type: StringArray,
      default: 'md'
    }
  },
  render: function render(h, ref) {
    var injections = ref.injections;
    var data = ref.data;
    var slots = ref.slots;
    var props = ref.props;
    var theme = injections.$chakraTheme();
    var sizes = theme.sizes;
    var pl = null;
    var pr = null;
    var height = inputSizes[props.size] && inputSizes[props.size].height;
    var children = slots().default.filter(function (e) {
      return e.tag;
    });
    var clones = children.map(function (vnode) {
      if (vnode.tag.includes('CInputLeftElement')) {
        pl = sizes[height];
      }

      if (vnode.tag.includes('CInputRightElement')) {
        pr = sizes[height];
      }

      if (kebabify(vnode.componentOptions.tag) === 'c-input') {
        var clone$1 = cloneVNode(vnode, h);
        return h(clone$1.componentOptions.Ctor, Object.assign({}, clone$1.data, {
          on: clone$1.componentOptions.listeners || {},
          props: Object.assign({}, clone$1.data.props || {}, clone$1.componentOptions.propsData, {
            size: props.size
          }),
          attrs: Object.assign({}, {
            borderRadius: clone$1.data.attrs.rounded,
            paddingLeft: clone$1.data.attrs.pl || pl,
            paddingRight: clone$1.data.attrs.pr || pr
          }, clone$1.data.attrs)
        }), vnode.componentOptions.children);
      }

      var clone = cloneVNode(vnode, h);
      return h(clone.componentOptions.Ctor, Object.assign({}, clone.data, clone.componentOptions.listeners || {}, {
        props: Object.assign({}, clone.data.props || {}, clone.componentOptions.propsData, {
          size: props.size
        })
      }), vnode.componentOptions.children);
    });
    return h(CBox, {
      props: {
        as: props.as
      },
      attrs: Object.assign({}, {
        display: 'flex',
        position: 'relative',
        zIndex: 0
      }, data.attrs, {
        'data-chakra-component': 'CInputGroup'
      })
    }, clones);
  }
};

export default CInputGroup;
